import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";

const primaryButtonBlurTimers = new WeakMap<
  HTMLElement,
  ReturnType<typeof setTimeout>
>();

document.addEventListener("pointerup", (event: PointerEvent) => {
  const target = event.target as HTMLElement | null;
  const primaryButton = target?.closest(".btn-primary") as HTMLElement | null;

  if (!primaryButton) {
    return;
  }

  const existingTimer = primaryButtonBlurTimers.get(primaryButton);
  if (existingTimer) {
    clearTimeout(existingTimer);
  }

  const timer = setTimeout(() => {
    primaryButton.blur();
    primaryButtonBlurTimers.delete(primaryButton);
  }, 400);

  primaryButtonBlurTimers.set(primaryButton, timer);
});

(window as any).MonacoEnvironment = {
  getWorkerUrl(_moduleId: string, label: string): string {
    const base = "./assets/monaco/vs/assets/";
    if (label === "json") return `${base}json.worker-DKiEKt88.js`;
    if (label === "css" || label === "scss" || label === "less")
      return `${base}css.worker-HnVq6Ewq.js`;
    if (label === "html" || label === "handlebars" || label === "razor")
      return `${base}html.worker-B51mlPHg.js`;
    if (label === "typescript" || label === "javascript")
      return `${base}ts.worker-CMbG-7ft.js`;
    return `${base}editor.worker-Be8ye1pW.js`;
  },
};

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
